import { render, staticRenderFns } from "./TrySampleButton.vue?vue&type=template&id=36d56429"
import script from "./TrySampleButton.vue?vue&type=script&lang=js"
export * from "./TrySampleButton.vue?vue&type=script&lang=js"
import style0 from "./TrySampleButton.vue?vue&type=style&index=0&id=36d56429&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports